import React from 'react'

const highlightStackTrace = (text?: string): JSX.Element => {
    const HIGHLIGHT_TERMS = [
        'NullPointerException',
        'Exception',
        'favrit',
        'Caused by',
        'AUTHORISED',
        'FAILED',
        'CAPTURED',
        'CAPTURE_FAILED',
        'CAPTURING',
    ]

    const lines = text?.split('\n') ?? []

    const escapeRegex = (term: string) => term.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
    const wordRegex = new RegExp(`(${HIGHLIGHT_TERMS.map(escapeRegex).join('|')})`, 'gi')

    return (
        <>
            {lines.map((line, idx) => {
                const shouldHighlightLine = HIGHLIGHT_TERMS.some((term) =>
                    line.toLowerCase().includes(term.toLowerCase())
                )

                const parts = line.split(wordRegex)

                return (
                    <div key={idx} className={shouldHighlightLine ? 'bg-purple-lightest' : undefined}>
                        {parts.map((part, i) =>
                            HIGHLIGHT_TERMS.some((term) => part.toLowerCase().includes(term.toLowerCase())) ? (
                                <span key={i} className="text-orange-darkest font-semibold">
                                    {part}
                                </span>
                            ) : (
                                <span key={i}>{part}</span>
                            )
                        )}
                    </div>
                )
            })}
        </>
    )
}

export default highlightStackTrace
